import { Photos } from 'ha/services/apiV2/types/Photos';
import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

export default (makeCall: MakeCall) => (
  listingId: number,
  { format }: { format: string },
) =>
  makeCall<Photos>('GET', `${APIV2_URL}/listing/${listingId}/photos`, {
    query: { format },
  });
